<template>
	<navbar />
	<div class="!min-h-screen">
		<router-view />
	</div>
	<landing-footer />
</template>

<script>
import { onBeforeMount, ref, computed } from "vue";
import store from "@/store";


import LandingFooter from "@/components/organisms/LandingFooter";
import Navbar from "@/components/organisms/Navbar.vue";
//toaster
import { createApp } from "vue"
import App from "../../App.vue"
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

export default {
	name: "LandingLayout",
	components: {
		Navbar,
		LandingFooter
	},

	setup() {
		const appLanguage = computed(() => { return store.getters.appLanguage })

		onBeforeMount(async () => {
			createApp(App).use(Toast, {
					rtl: appLanguage.value == 'ar'? true : false,
					toastClassName: "toaster-class"
			})

			//change body direction
			let bodyTag = document.getElementsByTagName('body')[0]
			if(appLanguage.value == 'ar') {
				bodyTag.setAttribute('dir','rtl')
			}else {
				bodyTag.setAttribute('dir','ltr')
			}
		
		});

		return {
			appLanguage,
		}
	}
}
</script>